import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class MatchArgs {
  taskId: string = ""
  languageCode: string = ""

  constructor(
    data: {
      taskId: string
      languageCode: string
    } | null = null,
  ) {
    if (data) {
      this.taskId = data.taskId
      this.languageCode = data.languageCode
    }
  }
}
